import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h2 className={`heading-lg ${light ? "text-white" : ""}`}>{title}</h2>
      {subtitle && (
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-white/80" : "text-ink-soft"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
